export default __webpack_public_path__ + "static/media/player.7760c323.png";